import { Box, type BoxProps } from '@mantine/core'
import { type PropsWithChildren } from 'react'

import styles from './styles.module.css'

export function Extra({ children }: PropsWithChildren<BoxProps>) {
  return <Box className={styles.extra}>{children}</Box>
}
